import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const LoaderContainer = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  "& > *": {
    color: "inherit",
    fontSize: "inherit",
    margin: theme.spacing(1)
  }
}));

type LoaderProps = {
  className?: string;
  size?: number;
  thickness?: number;
  text?: string;
  fontSize?: string;
  hideText?: boolean;
};

export default function Loader(props: Readonly<LoaderProps>) {
  const { 
    className,
    size,
    thickness,
    text,
    hideText,
    fontSize
  } = props;

  return (
    <LoaderContainer className={className}>
      <CircularProgress 
        disableShrink
        size={size ?? 32} 
        thickness={thickness ?? 4}
      />
      {!hideText && <Typography sx={{ fontSize: fontSize ?? "inherit" }}>{text ?? "Loading..."}</Typography>}
    </LoaderContainer>
  );
}
